export { useQueryAdDuration } from './useQueryAdDuration';
